import { render, staticRenderFns } from "./zhiapi.vue?vue&type=template&id=59651e0c&"
import script from "./zhiapi.vue?vue&type=script&lang=js&"
export * from "./zhiapi.vue?vue&type=script&lang=js&"
import style0 from "./zhiapi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports